import script from "./FeatureCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeatureCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./FeatureCarousel.vue?vue&type=style&index=0&id=4e84f930&lang=scss"

const __exports__ = script;

export default __exports__